import { motion } from "framer-motion";

const sections = [
  {
    title: "EMDR",
    subtitle: "Eye Movement Desensitization and Reprocessing",
    content: `
EMDR, travmatik yaşantıların ve yoğun duygusal deneyimlerin işlenmesine yönelik geliştirilen bilimsel temelli bir psikoterapi yöntemidir. Bu yaklaşım, kişinin geçmişte yaşadığı zorlayıcı anıların bugün üzerindeki etkisini azaltmayı ve bu anıların daha sağlıklı bir şekilde yeniden işlenmesini amaçlar. Terapötik süreçte belirli dikkat odaklama teknikleri ve çift yönlü uyarım yöntemleri kullanılır. EMDR, travma sonrası stres, kaygı, korkular ve bazı stres temelli psikolojik zorlukların ele alınmasında yaygın olarak kullanılmaktadır.
`,
  },
  {
    title: "Şema Terapi",
    subtitle: "Schema Therapy",
    content: `
Şema Terapi, erken dönem yaşam deneyimlerinin bireyin düşünce, duygu ve ilişki kalıpları üzerindeki etkisini ele alan bütüncül bir psikoterapi yaklaşımıdır. Bu terapi yöntemi, kişinin yaşam boyu tekrar eden uyumsuz düşünce ve davranış örüntülerini fark etmesine ve bunları dönüştürmesine yardımcı olmayı amaçlar. Terapötik süreçte bilişsel, duygusal ve deneyimsel teknikler birlikte kullanılır. Şema terapi; ilişkisel zorluklar, duygusal tekrar eden sorunlar ve kişilik yapılanmalarıyla ilişkili psikolojik süreçlerin ele alınmasında kullanılmaktadır.
`,
  },
  {
    title: "Somatik Terapi",
    subtitle: "Somatic Therapy",
    content: `
Somatik terapi, psikolojik süreçlerle bedensel deneyimler arasındaki ilişkiye odaklanan bir terapi yaklaşımıdır. Bu yaklaşım, stres, travma ve yoğun duygusal deneyimlerin bedende bıraktığı izleri fark etmeyi ve düzenlemeyi hedefler. Terapötik süreçte kişinin beden duyumlarına dikkat etmesi, bedensel farkındalık geliştirmesi ve sinir sistemi düzenlenmesine yönelik çalışmalar yapılır. Somatik terapi, özellikle travma, kronik stres, kaygı ve duygusal yoğunlukla ilişkili durumlarda destekleyici bir yaklaşım olarak kullanılmaktadır.
`,
  },
  {
    title: "Theraplay",
    subtitle: "",
    content: `
Theraplay, özellikle çocuk ve ebeveyn arasındaki ilişkiyi güçlendirmeyi hedefleyen etkileşim temelli bir terapi yaklaşımıdır. Bu yaklaşım, güvenli bağlanmayı desteklemeyi ve çocuk ile bakım veren arasındaki duygusal bağı güçlendirmeyi amaçlar. Terapötik süreçte oyun, temas, yapı ve karşılıklı etkileşim içeren etkinlikler kullanılır. Theraplay; bağlanma sorunları, duygusal düzenleme güçlükleri ve ebeveyn-çocuk ilişkilerinde yaşanan zorlukların ele alınmasında kullanılmaktadır.
`,
  },
  {
    title: "Bilişsel Davranışçı Terapi",
    subtitle: "Cognitive Behavioral Therapy – CBT",
    content: `
Bilişsel Davranışçı Terapi, düşünceler, duygular ve davranışlar arasındaki ilişkiye odaklanan yapılandırılmış bir psikoterapi yaklaşımıdır. Bu terapi yöntemi, kişinin işlevsel olmayan düşünce kalıplarını fark etmesine ve daha dengeli düşünme biçimleri geliştirmesine yardımcı olur. Terapötik süreçte problem çözme becerileri, davranış değişikliği ve düşünce yeniden yapılandırma teknikleri kullanılır. BDT; kaygı bozuklukları, depresyon, stres, obsesif düşünceler ve günlük yaşamda karşılaşılan çeşitli psikolojik zorlukların ele alınmasında etkili bir yöntem olarak kullanılmaktadır.
`,
  },
  {
    title: "Deneyimsel Oyun Terapisi",
    subtitle: "Experiential Play Therapy",
    content: `
Deneyimsel oyun terapisi, çocukların duygularını ve iç dünyalarını oyun aracılığıyla ifade etmelerine olanak sağlayan bir psikoterapi yaklaşımıdır. Bu yöntem, çocuğun güvenli bir terapötik ortamda yaşadığı deneyimleri keşfetmesini ve duygularını anlamlandırmasını destekler. Terapötik süreçte oyun, sembolik ifade ve ilişki odaklı etkileşimler önemli bir rol oynar. Deneyimsel oyun terapisi; duygusal zorluklar, davranış problemleri ve gelişimsel süreçlerde yaşanan güçlüklerin ele alınmasında kullanılmaktadır.
`,
  },
  {
    title: "Aktarım Odaklı Terapi",
    subtitle: "Transference Focused Psychotherapy – TFP",
    content: `
Aktarım Odaklı Terapi, psikodinamik temelli bir psikoterapi yaklaşımıdır ve özellikle kişinin ilişki örüntülerini anlamaya odaklanır. Bu yaklaşım, terapi ilişkisinde ortaya çıkan duygusal deneyimleri inceleyerek kişinin içsel dünyasını daha iyi anlamasını hedefler. Terapötik süreçte kişinin kendisi ve diğerleriyle kurduğu ilişkiler üzerine farkındalık geliştirilir. Aktarım Odaklı Terapi, özellikle ilişkisel zorluklar ve kişilik yapılanmalarıyla ilişkili psikolojik süreçlerin ele alınmasında kullanılmaktadır.
`,
  },
];

export default function CalismaAlanlari() {
  return (
    <section className="bg-gray-50 py-24 px-6 lg:px-12">
      <motion.div
        className="max-w-4xl mx-auto text-center space-y-6"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.0, ease: "easeInOut" }}
      >
        <h1 className="text-4xl font-bold text-gray-900">Çalışma Alanları</h1>
        <p className="text-gray-600 text-lg sm:text-xl max-w-2xl mx-auto">
          Danışanın ihtiyacına göre farklı psikoterapi yaklaşımlarıyla,
          bilimsel ve etik temelli bir terapi süreci yürütülür.
        </p>
      </motion.div>

      <div className="mt-16 max-w-4xl mx-auto space-y-6">
        {sections.map((section, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              duration: 0.8,
              delay: index * 0.08,
              ease: "easeInOut",
            }}
          >
            <h2 className="text-2xl font-semibold text-gray-900">
              {section.title}
            </h2>

            {section.subtitle && (
              <p className="mt-1 text-sm italic text-gray-500">
                ({section.subtitle})
              </p>
            )}

            {section.content.split("\n").map((line, i) =>
              line.trim() ? (
                <p key={i} className="mt-4 text-gray-700 leading-relaxed">
                  {line}
                </p>
              ) : null
            )}
          </motion.div>
        ))}
      </div>
    </section>
  );
}